module.exports = "/_next/static/images/CustomerDataFoundation-170916d6eafbfec561feadf033a71694.png";